module.exports = __webpack_public_path__ + "static/media/slider-l5-360.8ddde9f4.webp";